var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.768 4.59204L4.39835 17.1136C4.00911 17.5076 3.37735 17.5076 2.98712 17.1136C2.59789 16.7186 2.59789 16.0791 2.98712 15.684L15.3568 3.16348C15.746 2.76846 16.3777 2.76846 16.768 3.16348C17.1582 3.5575 17.1582 4.19701 16.768 4.59204ZM19.6982 2.88262L17.0444 0.280108C16.6512 -0.106834 16.0215 -0.0886467 15.6362 0.308398L0.286438 16.1043C0.1028 16.2932 0 16.5468 0 16.8125V19.1776C0 19.7363 0.446134 20 0.998047 20H3.28653C3.54702 20 3.79753 19.9909 3.98416 19.807L19.6992 4.30612C20.1004 3.90908 20.1004 3.27866 19.6982 2.88262Z",
    fill: "#878E99"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.7f7a836e2c1302b20cbd03164c4bf35b.svg";
export { ForwardRef as ReactComponent };